<template>
  <div>
    <div class="row no-gutters">
      <b-form-group class="col mr-1" :label="$t('Select User')">
        <user-search
          v-model="form.userId"
          class="card"
          :placeholder="$t('All Users')"
          :multiple="true"
        />
      </b-form-group>

      <b-form-group class="col-sm-6 col-md-4 mr-1">
        <date-range-filter
          :till-day-before="true"
          @change="dateChange"
        />
      </b-form-group>

      <div
        v-if="!IS_MOBILE() || usingCustomDateRange"
        class="d-flex col-sm-12 col-md-4"
      >
        <b-form-group class="col-6 px-0" :label="$t('Start Date')">
          <div class="d-flex align-items-center">
            <b-form-datepicker
              v-model="form.start_date"
              :date-format-options="IS_MOBILE() ? COMMON.MOBILE_DATE_PICKER_FORMAT : COMMON.DATE_PICKER_FORMAT"
              :max="form.end_date"
              :disabled="!usingCustomDateRange"
            />
          </div>
        </b-form-group>
        <b-form-group class="col-6 px-0 pl-1" :label="$t('End Date')">
          <div class="d-flex align-items-center">
            <b-form-datepicker
              v-model="form.end_date"
              :min="form.start_date"
              :max="maxDate()"
              :disabled="!usingCustomDateRange"
              :date-format-options="IS_MOBILE() ? COMMON.MOBILE_DATE_PICKER_FORMAT : COMMON.DATE_PICKER_FORMAT"
              :offset="-80"
            />
          </div>
        </b-form-group>
      </div>
    </div>

    <payment-table :form="form" />
  </div>
</template>
<script>
import { BFormDatepicker, BFormGroup, BOverlay, BFormSelect } from 'bootstrap-vue'
import UserSearch from '@/views/common/components/UserSearch.vue'
import DateRangeFilter from '@/views/common/components/DateRangeFilter.vue'
import PaymentTable from './components/Table.vue'

const moment = require('moment')

export default {
  components: {
    PaymentTable,
    BFormDatepicker,
    BFormGroup,
    BFormSelect,
    BOverlay,
    UserSearch,
    DateRangeFilter,
  },
  data() {
    return {
      form: {
        start_date: moment(this.SUBTRACT_DAYS(this.TODAY_COMPANY_TIME(), 1).start).startOf('month').format('YYYY-MM-DD HH:mm:ss'),
        end_date: this.maxDate(),
        userId: null,
      },
      isProcessing: false,
      usingCustomDateRange: false,
    }
  },
  methods: {
    maxDate() {
      return this.SUBTRACT_DAYS(this.TODAY_COMPANY_TIME(), 1).start
    },
    dateChange(range) {
      if (!range.startTime && !range.endTime) {
        this.usingCustomDateRange = true
        return null
      }
      this.form.start_date = range.startTime
      this.form.end_date = range.endTime
      this.usingCustomDateRange = false
      return null
    },
  },
}
</script>
<style lang="scss">
.blurry-text {
  color: transparent !important;
  text-shadow: 0 0 7px rgba(0, 0, 0, 0.6); /* Use rgba for better transparency control */
}
.dark-layout {
  .blurry-text {
    text-shadow: 0 0 7px rgba(255, 255, 255, 0.6);
  }
}
</style>
